import CheckInTemplate from './CheckInTemplate';

export default CheckInTemplate;
